export default [
    {
        path: '/home',
        component: require('./../../functional/Index').default,
        meta: {},
        children: [
            {
                path: '',
                name: 'Home',
                component: require('./../../views/Home/Home').default
            }
        ]
    }
]
